(() => {
'use strict';

const initAchievement=(container)=>{
if(!container)return;

const cards=container.querySelectorAll('.pg-feature-card');
const badges=container.querySelectorAll('.pg-certification-item');

const observer=new IntersectionObserver((entries)=>{
entries.forEach((entry)=>{
if(entry.isIntersecting){
container.classList.add('pg-visible');

cards.forEach((card,index)=>{
card.style.transitionDelay=`${index*120}ms`;
});

badges.forEach((badge,index)=>{
badge.style.transitionDelay=`${index*80}ms`;
});

observer.unobserve(container);
}
});
},{
threshold:.2,
rootMargin:'0px 0px -80px 0px'
});

observer.observe(container);
};

const init=()=>{
document.querySelectorAll('.pg-achievement').forEach((section)=>{
initAchievement(section);
});
};

document.addEventListener('DOMContentLoaded',init);

document.addEventListener('shopify:section:load',(event)=>{
const section=event.target.querySelector('.pg-achievement')||event.target;
initAchievement(section);
});

document.addEventListener('shopify:section:reorder',init);
document.addEventListener('shopify:block:select',init);
})();